import { Pipe, PipeTransform } from '@angular/core';
import * as momentN from 'moment'; const moment = momentN;

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {
  transform(value: Date | momentN.Moment, dateFormat: string): any {
      return moment(value).isValid() ? moment(value).format(dateFormat) : '';
  }
}
